<template>
  <v-dialog v-model="disconnectedSettingDialog" width="580">
    <custom-dialog>
      <template v-slot:title>
        <span>{{ tdl('abnormalStatusSetting') }}</span>
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="disconnectedSettingDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col id="dialog_content" class="ma-0 pa-6" cols="12">
            <!-- 通知時間設定 -->
            <v-row class="ma-0 pb-4 section_border" align="center">
              <v-col class="ma-0 pa-0 text-left" cols="6">
                <span class="label_font">{{ tdl('notificationTimeSetting') }}</span>
              </v-col>
              <v-col class="ma-0 pa-0" cols="6">
                <v-select class="ma-0 pa-0 custom_select" v-model="selectedTime" :items="timeList" dense hide-details
                  outlined dark item-text="label" item-value="value"></v-select>
              </v-col>
            </v-row>

            <v-row class="ma-0 pt-4 pb-4 section_border d-none">
              <v-col class="ma-0 pa-0 pb-2 text-left" cols="12">
                <span class="label_font">{{ tdl('notificationDestinationSetting') }}</span>
              </v-col>
              <v-col class="ma-0 pa-0" cols="12">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col class="ma-0 pa-0" cols="auto">
                    <input id="check_box" type="checkbox" v-model="enableEmailNotification" />
                  </v-col>
                  <v-col class="ma-0 pa-0 pl-2 ml-3" cols="8">
                    <v-text-field class="ma-0 pa-0 custom_textfield" v-model="emailAddress" dense hide-details outlined
                      dark placeholder="Email address"></v-text-field>
                  </v-col>
                  <v-col class="ma-0 pa-0 ml-auto" cols="3">
                    <v-btn class="ma-0 pa-0 blue_btn" width="100%" height="2.5rem" @click="sendTestEmail"
                      :loading="testEmailLoading">
                      {{ tdl('testEmailSend') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 pt-4 pb-4">
              <v-col class="ma-0 pa-0 pb-2 text-left" cols="12">
                <span class="label_font">{{ tdl('notificationAlarmSetting') }}</span>
              </v-col>
              <v-col class="ma-0 pa-0 admin_list_container" cols="12">
                <v-row class="ma-0 admin_list_item" v-for="(admin, index) in administratorList" :key="index"
                  align="center">
                  <v-col class="ma-0 pa-0" cols="auto">
                    <input id="check_box" type="checkbox" v-model="admin.checked" />
                  </v-col>
                  <v-col class="ma-0 pa-0 pl-4" cols="5">
                    <span class="admin_name">{{ admin.name }}</span>
                  </v-col>
                  <v-col class="ma-0 pa-0 text-right" cols="5">
                    <span class="admin_email">{{ admin.mailAddress }}</span>
                  </v-col>
                </v-row>
                <v-col class="ma-0 pa-10" cols="12" v-if="administratorList.length === 0" align="center">
                  <span style="color: #8E8E8E;">{{ t('noData') }}</span>
                </v-col>
              </v-col>
            </v-row>

            <!-- 버튼 -->
            <v-row class="ma-0 pa-0 pt-6" align="center" justify="center">
              <v-btn class="ma-0 pa-0 grey_btn" width="10rem" height="2.5rem"
                @click="disconnectedSettingDialog = false">{{ t('cancel') }}</v-btn>
              <v-btn class="ma-0 pa-0 ml-4 blue_btn" width="10rem" height="2.5rem" @click="saveSetting">
                {{ tdl('confirm') }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </custom-dialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
const HOURS_IN_DAY = 24;
export default {
  props: {
    dialogVisible: Boolean,
    selectedCamera: Object,
  },
  components: {
    CustomDialog
  },
  mixins: [mixin.common],
  data: () => ({
    activeTab: 0,
    disconnectedSettingDialog: false,
    isDisconnectedNotification: false,
    selectedTime: 300,
    isConnectedNotification: false,
    emailAddress: '',
    enableEmailNotification: false,
    testEmailLoading: false,
    administratorList: [],
    timeList: [
      // { label: '1分', value: 60 },
      // { label: '2分', value: 120 },
      { label: '3分', value: 180 },
      { label: '4分', value: 240 },
      { label: '5分', value: 300 },
      { label: '10分', value: 600 },
      { label: '30分', value: 1800 },
      { label: '1時間', value: 3600 },
    ]
  }),
  computed: {

  },
  watch: {
    dialogVisible: function (item) {
      this.disconnectedSettingDialog = item;
    },
    disconnectedSettingDialog: function (item) {
      this.$emit('visible', item);
      if (item) {
        this.initSettingData();
      }
    },
  },
  created() {
    this.initSettingData();
  },
  mounted() {

  },
  methods: {
    tdl(t) {
      return this.$t("lang.dialogs." + t);
    },
    initSettingData() {
      console.log('%cinitSettingData\n', "color:#008DD0;", this.selectedCamera);
      this.isDisconnectedNotification = this.isConnectedNotification = false;
      this.emailAddress = (this.$store.state.userData && this.$store.state.userData.userDetail && this.$store.state.userData.userDetail.mailAddress) || '';
      this.selectedTime = 600; // default 10 min
      this.enableEmailNotification = false;
      this.administratorList = [];

      if (this.selectedCamera) {
        this.selectedTime = Number(this.selectedCamera.disconnectedMailAlertTime) || 600;
        if (this.selectedTime < 180) this.selectedTime = 180;

        // 通知先設定 (manualMailRecipient)
        if (this.selectedCamera.manualMailRecipient) {
          const manual = this.selectedCamera.manualMailRecipient;
          this.enableEmailNotification = manual.isMailAlert || false;
          this.emailAddress = manual.mailAddress || this.emailAddress;
        }

        // 관리자 통지 설정 (mailRecipient)
        if (Array.isArray(this.selectedCamera.mailRecipient)) {
          this.administratorList = this.selectedCamera.mailRecipient.map(item => ({
            name: item.name,
            mailAddress: item.mailAddress,
            checked: item.isMailAlert,
            id: item.id || '',
            type: item.type || 'user'
          }));
        }
      }
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    isValidationParams() {
      if (!this.isValidEmail(this.emailAddress)) {
        this.showToastMessage(this.tmb('notValidEmail'));
        return false;
      }
      return true;
    },
    sendTestEmail() {
      if (!this.isValidEmail(this.emailAddress)) {
        this.showToastMessage(this.tmb('notValidEmail'));
        return;
      }

      this.testEmailLoading = true;
      // TODO: 테스트 메일 전송 API 호출
      setTimeout(() => {
        this.testEmailLoading = false;
        this.showToastMessage(this.tmb('requestSuccess'));
      }, 1000);
    },
    makeParams() {
      const selectedAdministrators = this.administratorList
        .map(admin => ({
          isMailAlert: admin.checked,
          name: admin.name,
          mailAddress: admin.mailAddress
        }));

      let params = {
        disconnectedMailAlertTime: this.selectedTime,
        manualMailRecipient: {
          isMailAlert: this.enableEmailNotification,
          name: '',
          mailAddress: this.emailAddress
        },
        mailRecipient: selectedAdministrators
      };

      setTimeout(() => {
        this.$emit('makeParams', {
          type: this.selectedCamera ? this.selectedCamera.type : undefined,
          unisCustomerCd: this.selectedCamera ? this.selectedCamera.unisCustomerCd : undefined,
          portNo: this.selectedCamera ? this.selectedCamera.portNo : undefined,
          params: params
        });
        this.disconnectedSettingDialog = false;
      }, 100);
    },
    saveSetting() {
      if (!this.isValidationParams()) return;
      this.makeParams();
    }
  }
}

</script>

<style lang="scss" scoped>
.label_font {
  color: white;
  font-size: 0.95rem;
  font-weight: bold;
}

.section_border {
  border-bottom: 1px solid #3d3d3d;
}

.custom_select {
  ::v-deep {
    .v-input__control {
      background-color: #272a33;

      .v-input__slot {
        border: 1px solid #ffffff !important;
        border-radius: 4px;

        fieldset {
          border: none;
        }
      }

      .v-select__selection {
        width: 100%;
        text-align: center;
        justify-content: center;
        color: white !important;
        font-size: 1.1rem;
      }
    }
  }
}

.custom_textfield {
  ::v-deep {
    .v-input__control {
      background-color: #272a33;

      .v-input__slot {
        border: 1px solid #3d3d3d !important;

        fieldset {
          border: none;
        }
      }
    }
  }
}

.admin_list_container {
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid #3d3d3d;
  scrollbar-width: thin;
  scrollbar-color: #555 #1a1c22;
}

.admin_list_item {
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 15px;
  border-bottom: 1px solid #3d3d3d;
}

.admin_name {
  color: white;
  font-size: 1rem;
}

.admin_email {
  color: #c0c0c0;
  font-size: 0.9rem;
}

.blue_btn {
  background-color: #008DD0 !important;
  color: white !important;
  font-size: 1rem;
  text-transform: none;
}

.grey_btn {
  background-color: #4a4a4a !important;
  color: white !important;
  font-size: 1rem;
  text-transform: none;
}

#dialog_exit {
  cursor: pointer;
  padding: 4px;
}

#btn_img {
  width: 24px;
  height: 24px;
}
</style>